import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import classes from '@nerdwallet/base-styles/classes';
import Image from '@nerdwallet/react-image';
import Link from '@nerdwallet/react-link';

import Type from '@nerdwallet/react-typography';

const CompanyEngBlogTile = ({ link, title, _embedded, excerpt }) => {
  const getTitleHTML = () => ({ __html: title.rendered });

  const getExcerptHTML = () => ({ __html: excerpt.rendered });

  const imageUrl = _.get(
    _embedded,
    'wp:featuredmedia.0.source_url',
    'https://www.nerdwallet.com/assets/img/nw-logos/NW_logo_200x200.png'
  );

  return (
    <div
      className={classNames([
        'eng-blog__tile',
        classes('margin-horizontal-auto'),
        classes('margin-horizontal-0--wide'),
        classes('padding-right-4--wide'),
        classes('margin-bottom-5'),
        classes('margin-bottom-4--wide'),
      ])}
    >
      <Link href={link} key={title.rendered} color="neutral-darkest">
        <div>
          {imageUrl && (
            <div>
              <Image
                src={imageUrl}
                alt={title.rendered}
                objectFit="cover"
                naturalHeight={232}
                naturalWidth={314}
                backgroundColor="transparent"
                imageClassName={classNames([
                  'eng-blog__image',
                  classes('margin-bottom-3'),
                ])}
              />
            </div>
          )}
        </div>
        <div>
          <Type
            size="3"
            chronicle
            dangerouslySetInnerHTML={getTitleHTML()}
            className={classNames([
              'eng-blog__title',
              classes('margin-bottom-3'),
              classes('text-align-left'),
            ])}
          />
          <Type
            size="1"
            default
            dangerouslySetInnerHTML={getExcerptHTML()}
            className={classNames([
              'eng-blog__excerpt',
              classes('margin-bottom-3'),
              classes('text-align-left'),
            ])}
          />
        </div>
      </Link>
    </div>
  );
};

CompanyEngBlogTile.propTypes = {
  link: PropTypes.string,
  _embedded: PropTypes.object,
  title: PropTypes.object,
  excerpt: PropTypes.object,
};

CompanyEngBlogTile.displayName = 'Company Engineering Blog Tile';

export default CompanyEngBlogTile;
